export default __webpack_public_path__ + "static/process-06-cd80314e08fbaa20f382f4672420c1f9.svg";